import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { ExtendedInsuranceSchema } from './InsuranceFormData';
import { ExtendedTaxesSchema } from './TaxesFormData';
import { ExtendedOptionsSchema } from './OptionsFormData';
import { ExtendedOneWayFeesSchema } from './OneWayFeesFormData';
import { ExtendedCarCategoriesSchema } from './CarCategoryFormData';
import { MarginRateSchema } from '@/types/common/margin-rate.schema';

export const CarRentalSchema = ExtendedInsuranceSchema.extend(
  ExtendedTaxesSchema.shape,
)
  .extend(ExtendedOptionsSchema.shape)
  .extend(ExtendedOneWayFeesSchema.shape)
  .extend(ExtendedCarCategoriesSchema.shape)
  .extend({
    name: z
      .string({ message: 'Le nom est requis' })
      .min(1, { message: 'Le nom est requis' }),
    supplier: isValidSelectorString('Le fournisseur est requis'),
    currency: isValidSelectorString('La devise est requise'),
    country: isValidSelectorString('Le pays est requis'),
    marginRate: MarginRateSchema.optional(),
    displayGlobalForm: z.enum(['true', 'false']).optional(),
  });

export type CarRentalFormData = z.infer<typeof CarRentalSchema>;
